import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function ChangedPasswordWithSuccess() {
  // variables
  const Navigate = useNavigate();

  // functions
  const handleConfirmButton = () => {
    Navigate('/login');
  };

  // render
  return (
    <main className="d-flex w-100">
      <div className="container d-flex flex-column">
        <div className="vh-50">
          <div className="mx-auto d-table w-50">
            <div className="d-table-cell align-middle">
              <Box className="text-center my-4">
                <img
                  className="img-fluid mb-4"
                  width="180"
                  height="48"
                  src="/img/logo.png"
                  alt="ビルドセルフ - BUILD-SELF"
                />
                <h2 className="text-bold my-3">
                  パスワードを変更いたしました
                </h2>

                <Box className="card">
                  <Box className="card-body">
                    <p className="text-start">
                      パスワードの変更が完了いたしました。パスワードは大切に保管ください。 引き続きサービスをご利用ください。
                      <br />
                      <br />
                    </p>
                    <Button
                      variant="contained"
                      onClick={handleConfirmButton}
                    >
                      ログイン画面へ
                    </Button>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ChangedPasswordWithSuccess;
